import { IOSSwitch } from '@adotel/components'
import { IconButton } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Remove'
import React from 'react'

import useStyles from './styles/InventoryCheckboxItem.styles'

interface InventoryCheckboxItemProps {
  label: string
  checked: boolean
  onToggle: () => void
  onDelete?: () => void
}

const InventoryCheckboxItem: React.FC<InventoryCheckboxItemProps> = ({
  label,
  checked,
  onToggle,
  onDelete
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.titleContainer}>
        {label}
        <IconButton onClick={onDelete} className={classes.deleteIconContainer}>
          <DeleteIcon className={classes.deleteIcon} />
        </IconButton>
      </div>
      <div className={classes.valueContainer}>
        <IOSSwitch checked={checked} color="primary" onChange={onToggle} />
      </div>
    </div>
  )
}

export default InventoryCheckboxItem
